import { useEffect, useState } from "react";

export default function AssignPackkyModal({
  open,
  onClose,
  subtotal = 0,
  discount = 0,
  cgstRate = 0,
  sgstRate = 0,
  cgstAmount = 0,
  sgstAmount = 0,
  gstType = "excl",
  deliveryCharge = 0,
  onDeliveryChargeChange,
  onConfirm,
}) {
  const [showChargeOptions, setShowChargeOptions] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(
    Number(deliveryCharge || 0),
  );

  const chargeOptions = [0, 20, 25, 50, 100];

  useEffect(() => {
    if (open) {
      setSelectedCharge(Number(deliveryCharge || 0));
    }
  }, [open, deliveryCharge]);

  if (!open) return null;

  const safeAmount = (value) => {
    const num = Number(value || 0);
    return Number.isFinite(num) ? Math.max(0, num) : 0;
  };

  const isInclusiveGst =
    String(gstType || "").toLowerCase() === "incl" ||
    String(gstType || "").toLowerCase() === "inclusive";

  const baseAmount = safeAmount(subtotal) - safeAmount(discount);

  const taxAmount = isInclusiveGst
    ? 0
    : safeAmount(cgstAmount) + safeAmount(sgstAmount);

  const grandTotal = Number(
    (baseAmount + taxAmount + safeAmount(selectedCharge)).toFixed(2),
  );

  const handleChargeSelect = (charge) => {
    const finalCharge = Number(charge || 0);

    setSelectedCharge(finalCharge);
    onDeliveryChargeChange?.(finalCharge);
  };

  const handleConfirm = () => {
    const finalCharge = Number(selectedCharge || 0);

    onDeliveryChargeChange?.(finalCharge);
    onConfirm?.(finalCharge);
  };

  return (
    <>
 
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[900px] rounded-xl bg-white shadow-2xl p-10">
        <div className="grid grid-cols-[1fr_260px] gap-6">
          {/* LEFT */}
          <div className="pr-6 border-r-2 border-dashed border-black">
            <h2 className="text-3xl font-semibold text-center mb-6">
              Assign To Packky
            </h2>

            <div className="border-t pt-4 space-y-3 text-lg">
              <div className="flex justify-between">
                <span>Subtotal</span>
                <span>₹ {Number(subtotal).toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Discount</span>
                <span>- ₹ {Number(discount).toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>CGST ({Number(cgstRate).toFixed(1)}%)</span>
                <span>₹ {Number(cgstAmount).toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>SGST ({Number(sgstRate).toFixed(1)}%)</span>
                <span>₹ {Number(sgstAmount).toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Delivery Charges</span>
                <span>₹ {Number(selectedCharge).toFixed(2)}</span>
              </div>

              <div className="border-t pt-3 flex justify-between text-xl font-bold">
                <span>Total</span>
                <span>₹ {grandTotal.toFixed(2)}</span>
              </div>
            </div>

            <div className="mt-5 rounded-md border bg-gray-50 px-4 py-3 text-sm font-semibold text-gray-600">
              Note: Delivery charges are{" "}
              {Number(selectedCharge) > 0 ? (
                <>
                  collected from the{" "}
                  <span className="text-red-500">customer</span>.
                </>
              ) : (
                <>
                  covered by the{" "}
                  <span className="text-red-500">restaurant</span>.
                </>
              )}
            </div>

            {showChargeOptions && (
              <div className="mt-4 rounded-lg border bg-white p-4 shadow-sm">
                <h4 className="text-center font-semibold mb-3">
                  Select Delivery Charges
                </h4>

                <div className="flex justify-center gap-3">
                  {chargeOptions.map((charge) => (
                    <button
                      key={charge}
                      onClick={() => handleChargeSelect(charge)}
                      className={`min-w-[80px] rounded-md border px-4 py-2 font-bold ${
                        Number(selectedCharge) === charge
                          ? "bg-emerald-600 text-white border-emerald-600"
                          : "bg-white text-gray-600 border-gray-400 hover:bg-gray-100"
                      }`}
                    >
                      ₹ {charge}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* RIGHT */}
          <div className="flex flex-col justify-center gap-5">
            <button
              onClick={handleConfirm}
              className="h-24 rounded-lg border border-gray-500 bg-white text-xl font-bold shadow hover:bg-gray-50"
            >
              OKAY
            </button>

            <button
              onClick={() => setShowChargeOptions((prev) => !prev)}
              className="h-24 rounded-lg border border-gray-500 bg-white text-xl font-bold text-emerald-700 shadow hover:bg-gray-50"
            >
              ADD CHARGES
            </button>

            <button
              onClick={onClose}
              className="h-24 rounded-lg border border-gray-500 bg-white text-xl font-bold shadow hover:bg-gray-50"
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
